import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/payroll-cycle-dates',
    name: 'payroll-cycle-date',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/payroll-cycle-date')
  }
]
